import { formatDisplayDateTime } from '../../lib/dateDisplay';
import React, { useEffect, useState } from 'react';
import { NoRecord } from '../../pages/HomePage';
import { RayTable, AdminProductACQListHeader, RayChartBar } from '../common';
import { Translate as t } from '../../config/Translate';

const ProductInfoAlignment = ({ product, showtable = true }) => {

	const [col, setCols] = useState([]);
	const [colEms, setColEms] = useState([]);
	const [show, setShow] = useState(false);
	const [alignments, setAlignments] = useState([]);
	const [emsalignments, setEmsAlignments] = useState([]);
	const [keyVal, setKeyVal] = useState({});

	const options = {
		keyCol: "_id",
		filterColumns: [],
		defaultSort: "timestamp",
		defaultSortType: -1
	}

	useEffect(() => {
		if (showtable) {
			if (product.emsalignments) {
				makeAlignEms();
			}
			if (product.alignments) {
				makeAlign();
			}
			setShow(true);
		} else {
			makeKeyVal();
		}
	}, [product]);

	const titleCase = s => s
		.replace(/(^|[_-])([a-z])/g, (a, b, c) => c.toUpperCase())
		.replace(/([a-z])([A-Z])/g, (a, b, c) => `${b} ${c}`);

	const makeAlignEms = () => {
		const list = [];
		product.emsalignments.map(x => {
			list.push(x);
		})

		setEmsAlignments(list);
		setColEms(createColsEMS(list));
	}

	const makeAlign = () => {
		const list = [];
		product.alignments.map(x => {
			if (!x.rawData)
				return;
			const mData = {};
			mData["timestamp"] = x.timestamp;
			const arr = x.rawData.split("////");
			const result = [];
			arr.map(y => {
				const item = y.split("//");
				if (item[0]) {
					if (item[0].indexOf("_VALUE") > -1) {
						return;
					}
					if (item[0].indexOf("_RESULT") > -1 || item[1].toUpperCase() == "RESULT") {
						result.push({ key: makeHeaderName(item[0]), val: item[2] });
					}
				}
			})
			result.map(m => {
				mData[m.key] = m.val;
			})
			mData["_id"] = x._id;
			list.push({ ...mData });
		})

		console.log(list);

		setAlignments(list);
		setCols(createCols(list));
	}

	const makeKeyVal = () => {
		const mData = {};
		product.alignments.map(x => {
			mData[t('product.label.lastInspection')] = formatDisplayDateTime(x.timestamp);
			const arr = x.rawData.split("////");
			const result = [];
			arr.map(y => {
				const item = y.split("//");
				if (item[0]) {
					if (item[0].indexOf("_VALUE") > -1) {
						return;
					}
					if (item[0].indexOf("_RESULT") > -1 || item[1].toUpperCase() == "RESULT") {
						mData[makeHeaderName(item[0])] = item[2];
					}
				}
			})
		})
		setKeyVal(mData)
	}

	const makeHeaderName = (str) => {
		return str.replace(".", "-")
			.replace(" ", "-")
			.replace("_RESULT", "")
			.replace("Alignment-", "")
			.replace(/-[0-9]-/g, '-')
			.replace(/-/g, ' ')
	}

	const createCols = (items) => {
		const list = [];
		let hasArray = false;
		items.map(x => {
			Object.keys(x).map(y => {
				if (Array.isArray(x[y])) {
					hasArray = true;
					return;
				}
				if (y == "_id") return;
				if (list.filter(m => m.name == y) == 0) {
					list.push({ name: y, label: titleCase(y), type: y.toUpperCase().indexOf("TIME") > -1 ? "DT" : "" });
				}
			});
		})
		if (hasArray)
			list.push({ name: "values", label: t('common.label.data'), type: "LISTTABLE" });

		return list;
	}

	const createColsEMS = (items) => {
		const list = [];
		let hasArray = false;
		items.map(x => {
			Object.keys(x).map(y => {
				if (Array.isArray(x[y])) {
					hasArray = true;
					return;
				}
				if (y == "_id") return;
				if (list.filter(m => m.name == y) == 0) {
					list.push({ name: y, label: titleCase(y), type: y.toUpperCase().indexOf("TIME") > -1 ? "DT" : "" });
				}
			});
		})
		if (hasArray)
			list.push({ name: "values", label: t('common.label.data'), type: "LIST" });
		return list;
	}

	console.log("=====");
	console.log(col);
	console.log("=====");

	return (
		<>
			{product.emsalignments &&
				<>
					{!showtable &&
						<>
							<ul className="listview simple-listview">
								{Object.entries(keyVal).map(([k, v]) =>
									<li className={(k == t('product.label.lastInspection') || v.toUpperCase() === "PASS") ? "" : "bg-danger"}>
										<strong>{k}</strong>
										<strong>{v}</strong>
									</li>
								)}
							</ul>
						</>
					}
					{showtable &&
						<>
							{show &&
								<div className="section">
									{product.emsalignments &&
										<div className="card">
											<div className="card-body">
												<RayTable
													data={product.emsalignments}
													columns={colEms}
													options={options} />
											</div>
										</div>
									}
								</div>
							}
						</>
					}
				</>
			}
			<>
				{!showtable &&
					<>
						<ul className="listview simple-listview">
							{Object.entries(keyVal).map(([k, v]) =>
								<li className={(k == t('product.label.lastInspection') || v.toUpperCase() === "PASS") ? "" : "bg-danger"}>
									<strong>{k}</strong>
									<strong>{v}</strong>
								</li>
							)}
						</ul>
					</>
				}
				{showtable &&
					<>
						{show &&
							<div className="section">
								{product.alignments &&
									<div className="card">
										<div className="card-body t-scroll">
											<RayTable
												data={alignments}
												columns={col}
												options={options} />
										</div>
									</div>
								}
							</div>
						}
					</>
				}
			</>
		</>
	);
};

export default ProductInfoAlignment;